import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { MedicalNoteActionType } from "@/Patient/Models/UI/MedicalNote/Enums/MedicalNote";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";
import { IPatientMedicalSummaryModel } from "@/Patient/Models/UI/MedicalSummary/IPatientMedicalSummaryModel";

interface IMedicalNoteActionWarningPopupProps {
    noteModel: IPatientMedicalNoteModel;
    medicalSummaryModel: IPatientMedicalSummaryModel;
    warningType: MedicalNoteActionType;
}

class MedicalNoteActionWarningPopupState {
    public isLoading: boolean;
}

class MedicalNoteActionWarningPopup extends React.Component<IMedicalNoteActionWarningPopupProps, MedicalNoteActionWarningPopupState> {
    private id: string = "actionwarningnotepopup";

    constructor(props: IMedicalNoteActionWarningPopupProps) {
        super(props);

        const initialState = new MedicalNoteActionWarningPopupState();
        initialState.isLoading = false;
        this.state = initialState;
    }

    public componentDidMount(): void {
        overlayStore.showOverlay(this.id);
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay(this.id);
    }

    public render(): JSX.Element {
        let currentEncounter;

        let noteModel = this.props.noteModel;
        let warningType = this.props.warningType;

        if (noteModel != null) {
            currentEncounter = noteModel.get("Encounter");
        }

        return (
            <Popup
                Id={this.id}
                title={cacheStore.GetString("WarningLabel")}
                closeTarget={warningType == MedicalNoteActionType.Delete
                    ? LocalPatientOperations.MedicalNote.DeleteNoteCancel
                    : LocalPatientOperations.MedicalNote.UnapproveNoteCancel
                }
                draggable={true}
                width={550}
                centeredHorizontally={true}
            >
                <div className="p-body">
                    <div>
                        <strong className="red-text"> {cacheStore.GetString("EncounterAuditWarningLabel")} </strong>
                    </div>
                </div>

                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button data-action="cancel" className="btn btn-default push-right-5" onClick={() => this.closePopup(warningType)}>{cacheStore.GetString("CancelLabel")}</button>
                                    <button className="btn btn-danger" disabled={this.state.isLoading} onClick={() => this.continue(currentEncounter.Id, currentEncounter.PatientId, warningType)} data-cy="medicalNoteWarningPopup-continue">{cacheStore.GetString("ContinueLabel")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private continue(encounterId: string, patientId: string, warningType: MedicalNoteActionType): void {
        this.mutateState(s => {
            s.isLoading = true;
        });

        switch (warningType) {
            case MedicalNoteActionType.Delete:
                sessionStore.dispatch(LocalPatientOperations.MedicalNote.DeleteNoteOK, { encounterId: encounterId, patientId: patientId });
                break;

            case MedicalNoteActionType.Unapprove:
                sessionStore.dispatch(LocalPatientOperations.MedicalNote.UnapproveNoteOK, { encounterId: encounterId, patientId: patientId });
                break;
        }
    }

    private closePopup(warningType: MedicalNoteActionType): void {
        switch (warningType) {
            case MedicalNoteActionType.Delete:
                sessionStore.dispatch(LocalPatientOperations.MedicalNote.DeleteNoteCancel);
                break;

            case MedicalNoteActionType.Unapprove:
                sessionStore.dispatch(LocalPatientOperations.MedicalNote.UnapproveNoteCancel);
                break;
        }
    }

    private mutateState(mutation: (s: MedicalNoteActionWarningPopupState) => void, then: any = null): void {
        let s = new MedicalNoteActionWarningPopupState();
        mutation(s);
        this.setState(s, then);
    }
}

export { MedicalNoteActionWarningPopup };
